import { BaseTooltipType } from "@/types/ui-kit/ui";
import { useEffect, useState } from "react";

export const BaseTooltip: React.FC<BaseTooltipType> = ({ visible, content, style, noTimeout, children }) => {
  const [tooltipTimeout, setTooltipTimeout] = useState(false);

  useEffect(() => {
    if (visible) {
      const timeout = setTimeout(() => {
        setTooltipTimeout(true);
      }, 1_000);

      return () => clearTimeout(timeout);
    }
    setTooltipTimeout(false);
  }, [visible]);

  return (
    <>
      {(tooltipTimeout || !!noTimeout) && (
        <div
          style={style}
          className={`${
            visible ? "hidden md:inline-flex" : "hidden"
          } absolute -top-[47px] z-10 rounded-full bg-white px-[18px] py-[7px] font-sans text-sm shadow-lg md:group-hover:block`}
        >
          <span className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-8 border-t-[8px] border-white border-x-transparent" />
          <div className="flex items-center justify-center gap-[8px] whitespace-nowrap">{content}</div>
          {children}
        </div>
      )}
    </>
  );
};
